function n() {
  return Math.random().toString(36).substring(2, 10);
}
export {
  n as generateRandomId
};
//# sourceMappingURL=index7.js.map
